import { io } from "socket.io-client";

const SOCKET_LOG_PREFIX = "[AdminCsvSocket]";

export const ADMIN_CSV_READY = "admin_csv_ready";
export const ADMIN_CSV_READY_WINDOW_EVENT = "admin-csv-ready";

export const REPORT_TYPES = {
  RESTAURANT_SALES: "restaurant_sales_report",
  RESTAURANT_ORDER: "restaurant_order_report",
};

export const REPORT_TYPE_LABELS = {
  [REPORT_TYPES.RESTAURANT_SALES]: "Restaurant Sales Report",
  [REPORT_TYPES.RESTAURANT_ORDER]: "Restaurant Order Report",
};

const getSocketUrl = () => {
  if (process.env.REACT_APP_SOCKET_URL) {
    return process.env.REACT_APP_SOCKET_URL.replace(/\/$/, "");
  }

  const apiUrl = process.env.REACT_APP_API || "";
  return apiUrl.replace(/\/v1\/?$/, "").replace(/\/$/, "");
};

export const createAdminCsvSocket = () => {
  const socketUrl = getSocketUrl();
  const token = localStorage.getItem("sessionToken");

  console.log(`${SOCKET_LOG_PREFIX} Connecting to`, socketUrl);

  const socket = io(socketUrl, {
    transports: ["websocket", "polling"],
    autoConnect: true,
    auth: token ? { token } : undefined,
    extraHeaders: token ? { Authorization: `Bearer ${token}` } : undefined,
  });

  socket.on("connect", () => {
    console.log(`${SOCKET_LOG_PREFIX} Connected`, {
      id: socket.id,
      url: socketUrl,
    });
  });

  socket.on("disconnect", (reason) => {
    console.log(`${SOCKET_LOG_PREFIX} Disconnected`, { reason });
  });

  socket.on("connect_error", (error) => {
    console.error(`${SOCKET_LOG_PREFIX} Connection error`, error?.message || error);
  });

  return socket;
};

export const getReportDownloadUrl = (payload = {}) =>
  payload?.xlsx_link ||
  payload?.file_url ||
  payload?.url ||
  payload?.download_url ||
  payload?.xlsx_url ||
  payload?.data?.xlsx_link ||
  payload?.data?.file_url ||
  payload?.data?.url ||
  null;

export const getReportTypeFromPayload = (payload = {}) =>
  payload?.type ||
  payload?.report_type ||
  payload?.data?.type ||
  payload?.data?.report_type ||
  null;
